// Loaded by the faqs section so it works on any template.
// Each section instance includes this script, so only the first copy runs.
import 'Styles/sections/gift-guide-sections.scss';

if (!window.giftGuideSectionsLoaded) {
  window.giftGuideSectionsLoaded = true;

  // Theme editor re-renders a section without a page load: wire its accordions (see components/accor.js).
  document.addEventListener('shopify:section:load', (event) => {
    if (window.accorInit) {
      event.target.querySelectorAll('[data-accor]').forEach(window.accorInit);
    }
  });
}
